import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../api/api";
import Footer from "../components/Footer";
import ArticleCard from "../components/ArticleCard";

export default function CategoryPage() {
    const { cat } = useParams();

    const [articles, setArticles] = useState([]); // ALWAYS array
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        API.get(`/api/articles/category/${cat}?page=${page}`)
            .then((res) => {
                console.log("CATEGORY API RESPONSE 👉", res.data);

                const list =
                    Array.isArray(res.data)
                        ? res.data
                        : Array.isArray(res.data?.articles)
                            ? res.data.articles
                            : Array.isArray(res.data?.items)
                                ? res.data.items
                                : Array.isArray(res.data?.data?.items)
                                    ? res.data.data.items
                                    : [];

                console.log("NORMALIZED ARTICLES 👉", list);

                setArticles(list);
                setTotalPages(
                    res.data?.total_pages ||
                    res.data?.data?.total_pages ||
                    1
                );
            })
            .catch((err) => {
                console.error("Category fetch error:", err);
                setArticles([]);
            })
            .finally(() => setLoading(false));
    }, [cat, page]);

    return (
        <div className="w-full">
            <div className="px-6 py-10 max-w-7xl mx-auto">

                {/* PAGE TITLE */}
                <h1 className="text-3xl font-bold mb-6 border-l-4 border-blue-600 pl-3 capitalize">
                    {cat.replace(/[_-]/g, " ")} Articles
                </h1>

                {/* LOADING */}
                {loading && (
                    <p className="text-center text-gray-500">
                        Loading articles...
                    </p>
                )}

                {/* ARTICLES */}
                {!loading && articles.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {articles.map((article) => (
                            <ArticleCard
                                key={article.slug}
                                slug={article.slug}
                                img={article.images}
                                title={article.title}
                                category={article.category}
                            />
                        ))}
                    </div>
                )}

                {/* EMPTY STATE */}
                {!loading && articles.length === 0 && (
                    <p className="text-gray-600 text-lg">
                        No articles found in this category.
                    </p>
                )}

                {/* PAGINATION */}
                {totalPages > 1 && (
                    <div className="flex justify-center items-center gap-4 mt-10">
                        <button
                            disabled={page === 1}
                            onClick={() => setPage((p) => p - 1)}
                            className="px-4 py-2 border rounded disabled:opacity-40"
                        >
                            ← Previous
                        </button>

                        <span className="px-4 py-2 bg-gray-100 rounded font-semibold">
                            Page {page} of {totalPages}
                        </span>

                        <button
                            disabled={page === totalPages}
                            onClick={() => setPage((p) => p + 1)}
                            className="px-4 py-2 border rounded disabled:opacity-40"
                        >
                            Next →
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
